const connectTheme = {
  '--color-white': 'rgba(255, 255, 255, 1)',
  '--elementos-ui-azul-01': '#001d3d',
  '--elementos-ui-azul-03': '#a3bed6',
  '--elementos-ui-azul-02': '#586983',
  '--elementos-ui-azul-05': '#eef7ff',
  '--elementos-ui-naranja-01': '#f15b2b',
  '--elementos-ui-naranja-03': '#f8a78d',
  '--elementos-ui-naranja-04': '#fcccbd',
  '--elementos-ui-naranja-05': '#fff2ee',
  '--alertas-error': '#f44336',
  '--alertas-error-claro': '#fff6f6',
  '--alertas-info': '#2979ff',
  '--marca-naranja-connect': '#f15b2b',
  '--nav-bar-blue-progress': '#178df6',
  '--nav-bar-blue-disabled': '#cadae8',
  '--elementos-ui-gris': '#e5e5e5',
  '--fondos-celeste': '#f9fcff',
  '--fondos-naranjas': '#fffaf9',
  '--alertas-exito-claro': '#ecf8e8',
  '--alertas-exito': '#43a047',
  '--alertas-advertencia': '#ffb41f',
  '--alertas-advertencia-claro': '#fff8ea',
  '--color-primary': '#F15B2B',
  '--color-primary-dark': '#bc5f1c',
  '--color-primary-action': '#e87722',
  '--color-primary-disabled': '#bfcdd2',
  '--color-background-primary': '#f8fafb',
  '--dark-color-background': '#111b22',
  '--color-text-primary': '#515151',
  '--color-tap': '#ebf2ff',
  '--bg-error': '#fddcda',
  '--bg-skeleton': '#e4e4e4',
  '--color-successful': '#43a047',
  '--bg-successful': '#dff0d8',
  '--color-disabled': '#c4c4c4',
  '--color-disabled-secondary': '#f5f6f8',
  '--color-azul-02': '#4799b4',
  '--color-text-disabled': '#7d92a1',
  '--color-text-disabled-secondary': '#b7b7b7',
  '--color-text-warning': '#ffb41f',
  '--color-text-black': '#000000',
  '--bg-warning': '#fff8ea',
  '--font-size-xs': '0.625rem',
  '--font-size-s': '0.75rem',
  '--font-size-m': '0.875rem',
  '--font-size': '1rem',
  '--font-size-l': '1.25rem',
  '--font-size-xl': '1.4rem',
  '--font-size-xxl': '1.813rem',
  '--accent-blue-01': '#c3dfeb',
  '--accent-blue-02': '#b9d3de',
  '--accent-blue-03': '#a0c0cd',
  '--accent-blue-04': '#7fadc0',
  '--accent-orange-01': '#ba5f1a',
  '--accent-orange-02': '#e96f24',
  '--accent-orange-03': '#ffa562',
  '--accent-orange-04': '#bb5f1b',
  '--accent-orange-05': '#ffe4cf',
  '--light-grey': '#ebf1f5',
  '--light-high-contrast': '#324552',
  '--light-medium-contrast': '#566976',
  '--dark-medium-contrast': '#acbac3',
  '--light-component-background-01': '#fff',
  '--gray-100': '#19191d',
  '--shadow-button-rounded': `
  0px 0px 0px 0px rgba(241, 91, 43, 0.1),
  2px 3px 8px 0px rgba(241, 91, 43, 0.1),
  6px 13px 14px 0px rgba(241, 91, 43, 0.09),
  14px 29px 19px 0px rgba(241, 91, 43, 0.05),
  25px 51px 23px 0px rgba(241, 91, 43, 0.01),
  40px 79px 25px 0px rgba(241, 91, 43, 0)
`,
  '--shadow-button-rounded-alt': `
    0px 0px 0px 0px rgba(0, 29, 61, 0.1),
    2px 3px 8px 0px rgba(0, 29, 61, 0.1),
    6px 13px 14px 0px rgba(0, 29, 61, 0.09),
    14px 29px 19px 0px rgba(0, 29, 61, 0.05),
    25px 51px 23px 0px rgba(0, 29, 61, 0.01),
    40px 79px 25px 0px rgba(0, 29, 61, 0)
  `,
  '--font-family-base': 'Connect',
  '--border-radius-input': '0rem',
  '--text-transform-title-checkout': 'uppercase',
  '--text-transform-title-price-checkout': 'uppercase',
  '--text-transform-item-price-checkout': 'uppercase',
  '--text-transform-header-steps-checkout': 'uppercase',
  '--text-transform-link': 'uppercase',
  '--text-transform-tap': 'uppercase',
  '--border-radius-btn-cupon': '0rem',
  '--border-radius-select': '0rem',
  '--border-radius-item-price': '0rem',
  '--border-radius-card': '0rem',
  '--border-radius-item-payment': '0rem',
  '--text-transform-detail-accordion': 'uppercase',
  '--text-transform-button': 'uppercase',
  '--btn-primary-bg': '#f15b2b',
  '--btn-primary-bg-hover': '#f8a78d',
  '--btn-primary-text': '',
  '--btn-primary-border': '',
  '--btn-primary-text-hover': '',
  '--btn-primary-border-hover': '',
  '--btn-primary-bg-disabled': '',
  '--btn-primary-text-disabled': '',
  '--color-brand-1': '#f15b2b',
  '--color-brand-2': '#001d3dd9',
  '--color-brand-3': '#A3BED6',
  '--letter-spacing': '0.02125rem',
  '--text-transform-summary-checkout': 'uppercase',
  '--color-brand-4': '#f15b2b',
  '--color-brand-5': '#f15b2b',
  '--color-brand-6': '#f15b2b',
  '--color-brand-7': '#f15b2b',
  '--color-brand-8': '#f15b2b',
  '--color-text-summary': '#fff',
  '--color-text-1': '#fff',
  '--header-steps-color-disabled': '#cadae8',
  '--secondary-btn-color': '#f44336',
  '--secondary-btn-background': '#ffffff',
  '--secondary-btn-border': '#ffffff',
};

export default connectTheme;
